export default __webpack_public_path__ + "static/18-d161ddb02d930c9971e05d4a345aff06.jpg";